export default __webpack_public_path__ + "static/media/H1015.2.a674cae5.mp3";